export const DirectAppointmentDialogOverridesMap = {};

export enum DirectAppointmentButtonOverrides {
  CancelText = 'cancelText',
  SubmitText = 'submitText',
  DisableSubmit = 'disableSubmit',
}
